import { useContext } from 'react';
import { UserContext } from './UserContext';

const useCurrentUser = () => useContext(UserContext);

export default useCurrentUser;
